export default {
    message: {
        "Ricerca_prodotti": "Búsqueda de productos",
        "Catalogo": "Catálogo",
        "Area": "área",
        "Categorie": "Categorías",
        "Marchi": "Marcas comerciales",
        "Stagione": "Temporada",
        "Prezzo": "Precio",
        "Genere": "Género",
        "Pagina": "Página",
        "di": "de",
        "Cerca": "Buscar",
        "vedi": "vedi",
        "totali": "total",
        "Nessun prodotto trovato": "No se encontraron productos.",
        "Caricamento prodotti in corso": "Cargando productos",
        "Aggiungi al carrello": "Añadir al carrito",
        "Loading": "Cargando ...",
    },
}
